import { getCurrentAppConfig } from "shared/config/appConfig"

import { request } from "./request"

export type CheckoutSessionResponse = {
  url: string
}

export type CustomerPortalLinkResponse = {
  _links: {
    self: {
      href: string
    }
  },
  url: string
}

export const packagesApi = {
  getPackages: (userID: number) => {
    return request('GET', `/provisioning-api/1/users/${userID}/stripe/packages`, undefined, { host: getCurrentAppConfig().provisioningApi })
  },
  checkoutSession: (userID: number, packageID: string): Promise<CheckoutSessionResponse> => {
    return request('POST', `/provisioning-api/1/users/${userID}/stripe/checkout_sessions`, { package_id: packageID }, { host: getCurrentAppConfig().provisioningApi })
  },
  getCustomerPortalLink: (userID: number): Promise<CustomerPortalLinkResponse> => {
    return request('POST', `/provisioning-api/1/users/${userID}/stripe/customer_portal_sessions`, {}, { host: getCurrentAppConfig().provisioningApi })
  },
  getOrders: (userID: number) => {
    return request('GET', `/provisioning-api/0/users/${userID}/orders`, undefined, { host: getCurrentAppConfig().provisioningApi })
  }
} 